import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { captureEvent, identifyUser } from './helper/postHog';
import { useAuthStore } from './store/useAuthStore';
import { useIntercomHelpers } from './helper/intercom';
import { INTERCOM_EVENTS } from './helper/intercom';
import { setUserContext } from './lib/sentry';

export default function AppContent({ children }: { children: React.ReactNode }) {
  const user = useAuthStore(state => state.user);
  const location = useLocation();
  const { trackEvent } = useIntercomHelpers();

  useEffect(() => {
    // Identify user if they are authenticated (have an id)
    if (user.id) {
      identifyUser(user);
      setUserContext({
        id: user.id,
        email: user.email,
        username: `${user.firstName} ${user.lastName}`.trim(),
        organization: user.organizationId || user.organizationName
      });
    }

    captureEvent('Page View', {
      path: location?.pathname || '',
      email: user.email ?? '',
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      timestamp: new Date().toISOString()
    });

    // Track page view in Intercom
    trackEvent(INTERCOM_EVENTS.PAGE_VIEWED, {
      path: location?.pathname || '',
      timestamp: new Date().toISOString()
    });
  }, [location?.pathname, user, trackEvent]); // Re-run the effect when the pathname changes or user data changes

  return <>{children}</>;
}
